import type { DailyCallState } from '@/hooks/use-daily-call'

const LABELS: Record<DailyCallState, string> = {
  idle: 'Starting',
  joining: 'Connecting',
  joined: 'In call',
  error: 'Couldn’t connect',
  left: 'Left',
}

export function dailyCallStateLabel(state: DailyCallState): string {
  return LABELS[state] ?? state
}
